import React from 'react';

function formatRevenue(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '₹0';
  if (Math.abs(num) >= 1_00_00_000) {
    return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(num / 1_00_00_000)} Cr`;
  }
  if (Math.abs(num) >= 1_00_000) {
    return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(num / 1_00_000)} L`;
  }
  return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(num)}`;
}

function formatPct(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '0%';
  return `${num.toFixed(1)}%`;
}

export default function TeamRevenueSplitPngCard({ reportDate, rows = [] }) {
  return (
    <div
      style={{
        width: 900,
        background: '#ffffff',
        fontFamily: 'Arial, Helvetica, sans-serif',
        color: '#1f2937',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #21B546 0%, #1a5276 100%)',
          color: '#ffffff',
          padding: '24px 28px',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>Team Revenue Split (MTD)</div>
        <div style={{ fontSize: 15, opacity: 0.95 }}>Report Date: {reportDate}</div>
      </div>

      <div style={{ padding: '20px 24px 24px' }}>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13,
          }}
        >
          <thead>
            <tr>
              {['Team', 'Altcase Revenue', '% Share'].map((label) => (
                <th
                  key={label}
                  style={{
                    background: '#34495e',
                    color: '#ffffff',
                    padding: '10px 8px',
                    textAlign: label === 'Team' ? 'left' : 'right',
                    border: '1px solid #2c3e50',
                    fontWeight: 600,
                  }}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.team_name}
                style={{
                  background: row.is_total ? '#e8f4f8' : '#ffffff',
                  fontWeight: row.is_total ? 700 : 400,
                }}
              >
                <td style={{ padding: '10px 8px', border: '1px solid #e0e0e0', textAlign: 'left' }}>
                  {row.team_name}
                </td>
                <td style={{ padding: '10px 8px', border: '1px solid #e0e0e0', textAlign: 'right' }}>
                  {formatRevenue(row.net_revenue)}
                </td>
                <td style={{ padding: '10px 8px', border: '1px solid #e0e0e0', textAlign: 'right' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                    <div
                      style={{
                        width: 80,
                        height: 8,
                        background: '#e5e7eb',
                        borderRadius: 4,
                        overflow: 'hidden',
                        flexShrink: 0,
                      }}
                    >
                      <div
                        style={{
                          width: `${Math.min(100, Math.max(0, Number(row.revenue_pct) || 0))}%`,
                          height: '100%',
                          background: row.is_total ? '#1a5276' : '#21B546',
                          borderRadius: 4,
                        }}
                      />
                    </div>
                    <span style={{ minWidth: 48 }}>{formatPct(row.revenue_pct)}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          background: '#2c3e50',
          color: '#ffffff',
          textAlign: 'center',
          padding: '14px 16px',
          fontSize: 12,
        }}
      >
        Altcase — Internal Sales Report
      </div>
    </div>
  );
}
